module.exports = __webpack_public_path__ + "img/bg2.1a66f872.jpg";